import React from "react";
import FinancialHero from "./FinancialHero";
import FinancialTrustBar from "./FinancialTrustBar";
import FinancialBenefits from "./FinancialBenefits";
import FinancialHowItWorks from "./FinancialHowItWorks";
import FinancialLoginSample from "./FinancialLoginSample";
import FinancialCompliance from "./FinancialCompliance";
import FinancialCta from "./FinancialCta";
import Footer from "../../components/Footer/Footer";
import { PageWrapper } from "../NinLanding/NinLanding.elements";
import SEOHelmet from "../../components/SEOHelmet/SEOHelmet";

const financialStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Credit Profile & BVN Verification Nigeria",
  "serviceType": "Financial Background Check",
  "provider": {
    "@type": "Organization",
    "name": "e-citizen",
    "url": "https://e-citizen.ng"
  },
  "description": "Check credit history, debt records, and financial standing for any Nigerian individual. BVN verification and comprehensive credit profile reports.",
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "url": "https://e-citizen.ng/credit-profile"
};

const FinancialVerificationPage = () => {
  return (
    <PageWrapper>
      <SEOHelmet
        title="Credit Score & BVN Verification Nigeria – Check Financial Profile | e-citizen"
        description="Check credit scores, BVN verification, debt history, and financial standing for any Nigerian individual. Get a comprehensive financial profile report in seconds. Powered by official credit bureau data."
        canonical="/credit-profile"
        keywords="BVN verification Nigeria, credit score check Nigeria, credit profile Nigeria, financial background check Nigeria, debt verification Nigeria, ecitizen credit"
        structuredData={financialStructuredData}
      />
      <FinancialHero />
      <FinancialTrustBar />
      <FinancialBenefits />
      <FinancialHowItWorks />
      <FinancialLoginSample />
      <FinancialCompliance />
      <FinancialCta />
      <Footer />
    </PageWrapper>
  );
};

export default FinancialVerificationPage;

